import React, {useState, useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import Headline from '#components/a/Headline'
import Input from '#components/a/form/Input'
import EditPen from '#components/svg/icons/EditPen'

function EditableText({value, placeholder, onBlur, onChange, validateInput}) {
  const [isEditable, setIsEditable] = useState(!value || value.trim() === '')
  const inputRef = useRef()

  const handleBlur = newValue => {
    onBlur(newValue)

    if (validateInput(newValue)) {
      setIsEditable(false)
    }
  }

  useEffect(() => {
    if (inputRef.current && isEditable) {
      inputRef.current.focus()
    }
  }, [isEditable])

  return (
    <div className="editable-text">
      {isEditable ? (
        <Input
          reference={inputRef}
          placeholder={placeholder}
          modifier="inline input--yellow-transparent"
          value={value}
          onBlurHandle={event => handleBlur(event.target.value)}
          onChangeHandle={event => onChange(event.target.value)}
        />
      ) : (
        <>
          <Headline importance={6} modifier="shy" text={value} />
          <button
            data-testid="button-edit-text"
            type="button"
            className="button--edit-text"
            onClick={() => setIsEditable(true)}
          >
            <EditPen />
          </button>
        </>
      )}
    </div>
  )
}

EditableText.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  validateInput: PropTypes.func,
}

export default EditableText
